import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'
import { useCookies } from 'vue3-cookies'
import { useUserStore } from '@/store/user'

const cookies = useCookies().cookies

export const useAuthStore = defineStore('auth', {
    state() {
        return {
            id: 0,
            email: '',
            is_active: false,
            is_superuser: false,
            is_verified: false,
            show_personality: false,
            allow_comments: false,
            role: '',
            permissions: '',
            register_msg: '',
            profile_pic: ''
        }
    },
    getters: {
        check_auth(state) {
            return (email) => {
                if (email == '') return false
                return state.email == email
            }
        },
        can_write_comments(state) {
            return state.permissions
        },
        get_permissions(state) {
            return state.permissions
        },
        can_edit_personality(state) {
            const userStore = useUserStore()
            let user = userStore.changeUser
            if (this.permissions) {
                if (this.permissions.indexOf('personalities') > -1) {
                    return true
                }
            }
            return user.email == state.email
        },
        personality_permission(state) {
            state
            if (this.permissions) {
                return this.permissions.indexOf('personalities') > -1
            }
            return false
        }
    },
    actions: {
        async login(email, password) {
            let data = { username: email, password: password }
            let res = await helper.api(
                'POST',
                '/auth/cooky_in_body/login',
                data,
                {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            )
            if (res) {
                if ('access_token' in res) {
                    cookies.set(
                        'access_token',
                        res['access_token'],
                        '30d',
                        '/',
                        '',
                        false,
                        'Lax'
                    )
                }
                await this.getCurrentUser()
            }
        },
        async logout() {
            this.id = 0
            this.email = ''
            this.is_active = false
            this.is_superuser = false
            this.is_verified = false
            this.show_personality = false
            this.allow_comments = false
            this.role = ''
            this.permissions = ''
            this.register_msg = ''
            this.profile_pic = ''
        },
        async remove_token() {
            cookies.remove('access_token')
        },
        async getCurrentUser() {
            let access_token = cookies.get('access_token')
            let user = await helper.api(
                'GET',
                '/users/cooky_in_body/me',
                {},
                { Authorization: 'Bearer ' + access_token }
            )
            if (user) {
                this.id = user.id
                this.email = user.email
                this.is_active = user.is_active
                this.is_superuser = user.is_superuser
                this.is_verified = user.is_verified
                this.show_personality = user.show_personality
                this.allow_comments = user.allow_comments
                // this.allow_comments = true
                this.profile_pic = user.profile_pic
                let role_request = await helper.api(
                    'GET',
                    '/public_users/role/' + user.role_id.toString(),
                    {},
                    {}
                )
                if (role_request) {
                    this.role = role_request.name
                    this.permissions = role_request.permissions
                }
            }
        },
        async register(newUser) {
            this.register_msg = await helper.api(
                'POST',
                '/public_users/register',
                newUser
            )
        },
        async forgotPassword(email) {
            const data = {
                email
            }
            await helper.api('POST', '/auth/forgot-password', data)
        },
        async resetPassword(token, newPassword) {
            const data = {
                token,
                password: newPassword
            }
            await helper.api('POST', '/auth/reset-password', data)
        }
    }
})
